<template>
  <div class="catalog-menu">
    <div class="container">
      <div class="catalog-menu__container">
        <div class="catalog-menu__header">
          <h1>Каталог</h1>
          <RouterLink to="/search">
            <svg width="36" height="36">
              <use xlink:href="@/assets/icons/sprite.svg#searchBtn"></use>
            </svg>
          </RouterLink>
        </div>
        <div class="catalog-menu__list">
          <div v-if="isLoading" class="loader">
            <div class="loader-spinner"></div>
          </div>
          <CatalogMenuItem v-else v-for="item in sections" :data="item" />
        </div>
      </div>
    </div>
  </div>
  <CartModal />
</template>
<script setup lang="ts">
  import CartModal from "@/components/CartModal.vue";
  import CatalogMenuItem from "@/components/CatalogMenuItem.vue";
  import { ISectionsItem } from "@/models/models";
  import { ref } from "vue";

  const sections = ref<Array<ISectionsItem>>([] as Array<ISectionsItem>);

  const isLoading = ref<boolean>(true as boolean);

  fetch("https://akshop.a-dev.xyz/api/v1/sections")
    .then((response) => response.json())
    .then((data) => {
      sections.value = data.sections;
      isLoading.value = false;
    });
</script>
<style lang="scss">
  .catalog-menu {
    &__header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 32px;
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 18px;
    }

    @include mediumMobile {
      padding: 12px 0px;
      &__header {
        min-height: 36px;
      }
    }
  }
</style>
